<div class="container">
  <div class="editor">
    <app-communication-editor class="col-12 p-nogutter" [triggerCommChange]="triggerCommChange" [(comm)]="comm"
                              [lead]="lead" [newLead]="newLead" [onCustomerChange]="customerChange" [editorLayout]="editorLayout">
    </app-communication-editor>
  </div>
  <div class="button-container">
    <w-button (action)="addNewCommunication()" label="Add Communication Record" icon="fas fa-plus"
              width="full"></w-button>
  </div>
</div>
